import type {DownloadListItem} from "~/components/download/types";

export default {
    name: "XSQUARE PGHS + XRAD",
    stats: {
        "Version": "5.3.3.4.3.4",
        // "File size":  "30 MB",
        "Update": "June 2, 2025"
    },
    descriptionTitle: "",
    description: "",
    buttons: {
        "Download" : "https://xsquare.dev/files/edu/"
    }
} as DownloadListItem
